module.exports = __webpack_public_path__ + "media/site_templates/www.excavate.company/images/our_services_2-d2f5d18e8c32b3020aef8dc60eda6615.jpg";